import React,{ useState, useEffect } from 'react';

import bigFeuille from '../../assets/images/bigfeuille-bg.png';
import maison from "../../assets/images/maison.svg";
import calendrier from "../../assets/images/calendrier.svg";
import {urlBase, urlDirectus} from "../../config/Globals";
import ArticleSevice from "../../service/Article";
import {Partenaires} from "../Home/Partenaires";

export const Historique = ({ rubrique }) => {

    const[articles, setArticles] = useState([]);
    const[loadingArticles, setLoadingArticles] = useState(1);
    const fetchArticles = async(id) => {
        try{
            const data = await ArticleSevice.findAllInRubrique(id);
            setArticles(data);
            setLoadingArticles(false);
        }catch (error){

        }
    }
    useEffect(() => {
        if(rubrique.id) {
            fetchArticles(rubrique.id);
        }
    }, [rubrique.id]);

    return (
        <>
            <main class="type historique-campagnes">
                <section className="bg-light">
                    <div className="container px-4 pt-lg-5 pb-5 position-relative z-1">
                        <img src={bigFeuille} alt="Feuilles"
                             className="col-10 col-lg-6 position-absolute end-0 top-0 pe-4 pe-lg-0 pt-5 z-0"/>
                        <div className="row pt-lg-4 pb-lg-5 position-relative z-1">
                            <div className="col-12">
                                <nav aria-label="breadcrumb" className="my-4">
                                    <ol className="custom-breadcrumb">
                                        <li className="breadcrumb-item-custom">
                                            <a href={urlBase} className="breadcrumb-link-home">
                                                <img src={maison} alt="Accueil" className="breadcrumb-icon"/>
                                            </a>
                                        </li>
                                        <li className="breadcrumb-separator">•</li>

                                        <li className="breadcrumb-item-custom">
                                            <a href={urlBase + 'tout-savoir-sur-la-flavescence-doree'}
                                               className="breadcrumb-link">
                                                Tout savoir sur la flavescence dorée
                                            </a>
                                        </li>

                                        <li className="breadcrumb-separator">•</li>

                                        <li className="breadcrumb-item-custom active" aria-current="page">
                                            {rubrique.titre}
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                            <div className="col-12">
                                <h1 className="display-5 fw-sb mb-3">{rubrique.titre}</h1>
                                <div className="fw-b fs-6">
                                    <p>{rubrique.resume}</p>
                                </div>
                            </div>
                        </div>

                        {
                            articles.map((article, index) => (
                                <div className="row py-3 py-lg-5 position-relative z-1">
                                    <div className="col-12 col-lg-3 pe-lg-0">
                                        <img src={article.images && urlDirectus+"assets/"+article.images[0].item} alt={article.titre} className="visuel-en-ce-moment w-100 h-100 object-fit-cover"/>
                                    </div>
                                    <div className="col-12 col-lg-9 ps-lg-0">
                                        <div className="bg-white p-4 p-md-5 d-flex flex-column align-items-start">
                                            <h2 className="fw-sb mb-4">{article.titre}</h2>
                                            <div className="d-flex align-items-center justify-content-center justify-content-lg-start gap-2 fs-5 mb-2 text-marron">
                                                <img src={calendrier} alt="" className="object-fit-contain"/>
                                                <span className="date-en-ce-moment">{new Date(article.date_publication).toLocaleDateString('fr-FR')}</span>
                                            </div>
                                            <div className="fs-6 lh-normal mb-4" dangerouslySetInnerHTML={{__html : article.contenu}}>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </section>
                <Partenaires />
            </main>
        </>
    );
}